import type { Listing } from 'shared/@types';

const listingPreviewCache = new Map<string, Listing>();
const MAX_LISTING_PREVIEW_CACHE_ENTRIES = 30;

export function setListingPreview(listing: Listing) {
  if (!listing.slug) {
    return;
  }

  if (listingPreviewCache.has(listing.slug)) {
    listingPreviewCache.delete(listing.slug);
  }

  listingPreviewCache.set(listing.slug, listing);

  if (listingPreviewCache.size <= MAX_LISTING_PREVIEW_CACHE_ENTRIES) {
    return;
  }

  const oldestKey = listingPreviewCache.keys().next().value;

  if (oldestKey) {
    listingPreviewCache.delete(oldestKey);
  }
}

export function getListingPreview(slug: string | string[] | undefined) {
  if (!slug || Array.isArray(slug)) {
    return undefined;
  }

  return listingPreviewCache.get(slug);
}

export function clearListingPreviews() {
  listingPreviewCache.clear();
}
